export type ZIndexLayer =
    | 'base'
    | 'modal-backdrop'
    | 'modal'
    | 'confirm-backdrop'
    | 'confirm'
    | 'popover'
    | 'tooltip'
    | 'toast-backdrop'
    | 'toast'
    | 'loading-screen';

/** Reads a z-index layer from theme.css, for code that needs a number (e.g. Highcharts options). */
export function getZIndex(layer: ZIndexLayer) {
    return Number(
        getComputedStyle(document.documentElement).getPropertyValue(`--z-index-${layer}`)
    );
}
